module.exports = __webpack_public_path__ + "img/door.16a02d5f.jpg";